import { pollInstance } from '@/axios';

/* eslint-disable no-param-reassign */

const toolConfigurationModule = {
	actions: {
		async createNewTool({ dispatch }, body) {
			await pollInstance.post('tools', body);
			await dispatch('loadTools');
		},
		async createLevel({ dispatch }, { toolCode, ...rest }) {
			const url = `hierarchies/${toolCode}`;
			await pollInstance.post(url, rest);
			dispatch('toolDetail', toolCode);
		},
		async delete({ dispatch }, id) {
			await pollInstance.delete(`tools/${id}`);
			await dispatch('loadTools');
		},
		async editLevel({ dispatch }, { toolCode, id, ...rest }) {
			const url = `hierarchies/${id}`;
			await pollInstance.patch(url, rest);
			dispatch('toolDetail', toolCode);
		},
		async editTool({ dispatch }, { id, ...body }) {
			const url = `tools/${id}`;
			await pollInstance.patch(url, body);
			await dispatch('loadTools');
		},
		async loadTool({ commit, dispatch }, code) {
			const url = `tools/${code}`;
			const { data: response } = await pollInstance.get(url);
			const {
				answerId,
				description,
				id,
				images,
				name,
				templateId,
				urlImage: { web: urlImage },
				videos,
			} = response;
			const toolData = {
				code,
				description,
				id,
				image: '',
				images,
				name,
				templateId,
				urlImage,
				videos,
				videoLink: '',
			};
			commit('SET_EDITING_TOOL_ID', toolData.id);
			commit('SET_EDITING_TOOL', toolData);
			commit('NEW_TOOL_TEMPLATE_ID', templateId);
			dispatch('answer/selectedTypeAnswer', answerId, { root: true });
			dispatch('icon/callingIconsAndSelectingIt', urlImage, { root: true });
		},
		async loadTools({ commit }) {
			const { data: response } = await pollInstance.get('tools');
			const responseFilter = response.filter(t => t.id !== 22 && t.id !== 23);
			commit('SET_TOOLS', responseFilter);
		},
		async loadToolType({ commit }) {
			const { data: res } = await pollInstance.get('templates');
			commit('SET_TOOLS_TEMPLATES', res);
		},
		selectTemplate({ commit }, template) {
			commit('NEW_TOOL_TEMPLATE_ID', template.id);
		},
		setFlagEditTool({ commit }, id) {
			commit('SET_EDITING_TOOL_ID', id);
		},
		setNewToolData({ commit }, newTool) {
			commit('NEW_TOOL_TEMPLATE_ID', newTool.templateId);
			commit('NEW_TOOL_DESCRIPTION', newTool.description);
			commit('NEW_TOOL_NAME', newTool.name);
			commit('NEW_TOOL_CODE', newTool.code);
		},
		async toolDetail({ commit }, toolCode) {
			const url = `hierarchies/${toolCode}`;
			const { data: res } = await pollInstance.get(url);
			commit('SET_TOOLS_DETAIL', res);
		},
	},
	state: {
		details: null,
		editing: {
			id: 0,
			toolData: {},
		},
		templateId: 0,
		templates: [],
		newToolCode: '',
		newToolDescription: '',
		newToolName: '',
		tools: [],
		urlImage: null,
	},
	mutations: {
		NEW_TOOL_TEMPLATE_ID(state, id) {
			state.templateId = id;
		},
		NEW_TOOL_CODE(state, code) {
			state.newToolCode = code;
		},
		NEW_TOOL_DESCRIPTION(state, description) {
			state.newToolDescription = description;
		},
		NEW_TOOL_NAME(state, name) {
			state.newToolName = name;
		},
		SET_EDITING_TOOL(state, data) {
			state.editing.toolData = data;
		},
		SET_EDITING_TOOL_ID(state, id) {
			state.editing.id = id;
		},
		SET_TOOLS(state, tools) {
			state.tools = tools;
		},
		SET_TOOLS_DETAIL(state, toolsDetail) {
			state.details = toolsDetail;
		},
		SET_TOOLS_TEMPLATES(state, templates) {
			state.templates = templates;
		},
	},
	getters: {
		getDetails(state) {
			return state.details;
		},
	},
};

export default toolConfigurationModule;



// WEBPACK FOOTER //
// ./src/store/modules/toolConfigurartion/index.js